// ABOUTME: Minus icon for counter decrease and subtraction actions
// ABOUTME: Supports className, size, and color customization

interface MinusIconProps {
  className?: string
  size?: number
  color?: string
}

export const MinusIcon = ({ className = "", size = 14, color = "black" }: MinusIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.1875 10.7625C15.1875 10.9482 15.118 11.1262 14.9942 11.2575C14.8704 11.3887 14.7025 11.4625 14.5275 11.4625H4.8475C4.67246 11.4625 4.50458 11.3887 4.38081 11.2575C4.25704 11.1262 4.1875 10.9482 4.1875 10.7625C4.1875 10.5768 4.25704 10.3988 4.38081 10.2675C4.50458 10.1362 4.67246 10.0625 4.8475 10.0625H14.5275C14.7025 10.0625 14.8704 10.1362 14.9942 10.2675C15.118 10.3988 15.1875 10.5768 15.1875 10.7625Z"
      fill={color}
    />
  </svg>
)
